import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Notification, NotificationType } from 'ah-api-gateways';
import FileExportCard from './FileExportCard.vue';
import { formatDistance, isSameDay, isToday, isYesterday } from 'date-fns';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useAhNotificationState } from '../..';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileExportsList',
  setup(__props) {

const requestManager = useRequestManager({
  exposeToParent: true,
  onRetryFromParentManager: onRetryFromParentManager,
});

const notificationState = useAhNotificationState();

const notifications = computed(() => notificationState.store.useNotificationsStore().fileExportNotifications);

const hasMoreNotifications = computed(
  () => notificationState.store.useNotificationsStore().fileCount > notifications.value.length
);

const noNotifications = computed(() => !notifications.value || notifications.value.length === 0);

function onRetryFromParentManager(k: string) {
  if (k === 'loadNotifications') {
    loadMoreItems();
  }
}

function onFileDownload(item: Notification) {
  requestManager.manager
    .currentOrNew(
      `download-${item.id}`,
      notificationState.services.documents.downloadSyncDocument(item.resourceOrigin!, item.resource!)
    )
    .subscribe();
}

function onInfiniteLoad(intersection: IntersectionObserverEntry) {
  if (intersection.isIntersecting) {
    loadMoreItems();
  }
}

function isItemDownloading(item: Notification) {
  return requestManager.manager.requestStates[`download-${item.id}`] === 'pending';
}

function isSameDayAs(a: Notification, b: Notification) {
  return isSameDay(new Date(a.createdAt), new Date(b.createdAt));
}

function loadMoreItems() {
  requestManager.manager.newPromise(
    'loadNotifications',
    notificationState.store.useNotificationsStore().loadFileNotifications()
  );
}

function markAsRead(notification: Notification) {
  notificationState.store.useNotificationsStore().markAsRead(notification);
}

function formatDate(date: string) {
  if (isToday(new Date(date))) {
    return 'TODAY';
  } else if (isYesterday(new Date(date))) {
    return 'YESTERDAY';
  }

  return formatDistance(new Date(date), new Date(), { addSuffix: true });
}

if (notifications.value.length === 0) {
  notificationState.store.useNotificationsStore().loadFileNotifications();
}

return { __sfc: true,requestManager, notificationState, notifications, hasMoreNotifications, noNotifications, onRetryFromParentManager, onFileDownload, onInfiniteLoad, isItemDownloading, isSameDayAs, loadMoreItems, markAsRead, formatDate, NotificationType, FileExportCard }
}

})